export default __webpack_public_path__ + "static/media/22.069bf30c.gif";